<app-relatorio-container
    tituloRelatorio="Recibo de Protocolo"
    descricaoRelatorio="Recibo de protocolo de solicitação (baseado no número do protocolo, não no prestador)."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'recibo-protocolo-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <div class="field">
                <label for="nuProtocolo" class="font-semibold block mb-2">Número do Protocolo</label>
                <p-inputnumber inputId="nuProtocolo" formControlName="nuProtocolo" [useGrouping]="false" [min]="1" placeholder="Informe o número do protocolo" styleClass="w-full" class="w-full"></p-inputnumber>
                @if (form.get('nuProtocolo')?.invalid && form.get('nuProtocolo')?.touched) {
                    <small class="p-error mt-2" style="color: red">Informe o número do protocolo.</small>
                }
            </div>

            <div class="field">
                <label for="nuAno" class="font-semibold block mb-2">Ano</label>
                <p-inputnumber inputId="nuAno" formControlName="nuAno" [useGrouping]="false" [min]="1900" [max]="9999" placeholder="Informe o ano do protocolo" styleClass="w-full" class="w-full"></p-inputnumber>
                @if (form.get('nuAno')?.invalid && form.get('nuAno')?.touched) {
                    <small class="p-error mt-2" style="color: red">Informe um ano válido.</small>
                }
            </div>

            <div class="field">
                <label for="tipoProtocolo" class="font-semibold block mb-2">Tipo de Protocolo</label>
                <p-inputnumber inputId="tipoProtocolo" formControlName="tipoProtocolo" [useGrouping]="false" [min]="1" placeholder="Tipo de protocolo (opcional)" styleClass="w-full" class="w-full"></p-inputnumber>
                <small class="block mt-2 text-color-secondary">Opcional. Padrão: 1 (Inscrição Pré-Prestador).</small>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Recibo" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending || form.invalid"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
